import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/admin.scss';
import { ApiHelper } from '../../apiHelper/ApiHelper';

type Faculty = { id: string; name: string; examDate?: string | null; testModel: number; ranges: number };
const MODEL: { [k: number]: string } = { 0: "Jednoduchý", 1: "Jednoduchý + žádná", 2: "Kombinovaný" };

function fmt(d?: string | null) { if (!d) return "—"; const x = new Date(d); return x.getDate() + ". " + (x.getMonth() + 1) + ". " + x.getFullYear(); }

export default function AdminFaculties() {
    const [faculties, setFaculties] = useState<Faculty[]>([]);
    const [loaded, setLoaded] = useState(false);
    const navigate = useNavigate();
    const api = new ApiHelper();

    useEffect(() => { load(); }, []);
    async function load() { try { setFaculties(await (await api.adminFacultiesApi.list()).json()); } catch (x: any) { api.adminError(x); } finally { setLoaded(true); } }

    return (
        <div>
            <div className="adminHead">
                <div><h1>Fakulty</h1><p>Cílové fakulty, termíny přijímaček a modely testů</p></div>
                <button className="aBtn" onClick={() => navigate("/admin/fakulty/new")}>+ Nová fakulta</button>
            </div>

            <table className="aTable">
                <thead><tr><th>Název</th><th>Termín přijímaček</th><th>Model testu</th><th>Předměty</th></tr></thead>
                <tbody>
                    {faculties.map(f => (
                        <tr key={f.id} onClick={() => navigate("/admin/fakulty/" + f.id)}>
                            <td>{f.name}</td>
                            <td>{f.examDate ? fmt(f.examDate) : <span className="muted">nezveřejněno</span>}</td>
                            <td>{MODEL[f.testModel]}</td>
                            <td>{f.ranges}</td>
                        </tr>
                    ))}
                    {loaded && faculties.length === 0 && <tr><td colSpan={4} className="muted">Žádné fakulty.</td></tr>}
                </tbody>
            </table>
        </div>
    );
}
